module.exports = __webpack_public_path__ + "img/back-1.fef922aa.jpg";